import { Outlet } from 'react-router-dom'
import { EditorTopbar } from './EditorTopbar'

/**
 * Authenticated shell — mirrors the original FastAPI page:
 *   - file-editor-style topbar pinned to the very top (Briefer wordmark,
 *     user-email path, brief-status indicator, language flag chips,
 *     Open / Save / Save As / History / Submit, logout)
 *   - whatever route renders inside `.wrap`, which inherits the same
 *     gutter as the original `lorenza.html` page.
 *
 * The Masthead + Stepper + Dock live inside the routed page (Intake/
 * Dashboard/Briefs etc.) — the original lorenza.html mounts them only on
 * the form view, not on /briefs or /login, and we mirror that.
 */
export function AppLayout() {
  return (
    <>
      <EditorTopbar />
      <div className="wrap">
        <main>
          <Outlet />
        </main>
      </div>
    </>
  )
}
